export default __webpack_public_path__ + "static/icon-tile-color-dark-50c5ba61aa07c83bb80e8b550e83a13d.png";